module.exports = __webpack_public_path__ + "f46c6f668fc2ec189383004cd460ade9.png";